import { useEffect } from "react";
import Nav from "@/components/landing/Nav";
import Hero from "@/components/landing/Hero";
import Learn from "@/components/landing/Learn";
import Inside from "@/components/landing/Inside";
import WhyBuy from "@/components/landing/WhyBuy";
import Pricing from "@/components/landing/Pricing";
import Reviews from "@/components/landing/Reviews";
import FAQ from "@/components/landing/FAQ";
import Footer from "@/components/landing/Footer";
import MobileSticky from "@/components/landing/MobileSticky";
import { toast } from "sonner";
import { useSearchParams } from "react-router-dom";

export default function Landing() {
  const [params, setParams] = useSearchParams();

  useEffect(() => {
    document.title =
      "The 9-to-5 Exit Blueprint — Day Trading Ebook for Beginners";

    const meta = document.querySelector('meta[name="description"]') ||
      Object.assign(document.createElement("meta"), { name: "description" });
    meta.setAttribute(
      "content",
      "Master the basics of day trading step-by-step. A beginner's visual guide to reading the markets, controlling risk, and building a trading routine. Instant digital access — $199.99."
    );
    document.head.appendChild(meta);
  }, []);

  useEffect(() => {
    if (params.get("canceled") === "1") {
      toast.info("Checkout canceled. You can purchase any time.");
      params.delete("canceled");
      setParams(params, { replace: true });
    }
  }, [params, setParams]);

  return (
    <main
      data-testid="landing-page"
      className="relative bg-[#050505] text-white min-h-screen font-body overflow-x-hidden"
    >
      <Nav />
      <Hero />
      <Pricing />
      <Learn />
      <WhyBuy />
      <Inside />
      <Reviews />
      <FAQ />
      <Footer />
      <MobileSticky />
    </main>
  );
}
